<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Dashboard</li>
  </ol>
</nav>
<div *ngIf="!loading">
  <!--<div>-->
  <div class="row">
    <div class="my-1 col-12">
      <div class="widget widget-welcome-header">
        <div class="widget-content font-24 text-primary">
          <div class="row">
            <div class="col-9">
              {{ 'Welcome' | translate }} {{ myBusinessDashboard?.myBusiness.licenseName ?? '...' }}
              <span style="font-size: 8pt;color: red">
                ({{ 'your package is ' | translate }} {{ myBusinessDashboard?.myBusiness.merchantPackage.paylinkSubscriptionNameAr ?? '...' }})
              </span>
            </div>
            <!--            <div class="col-3" *ngIf="monthlyLimitPercentage != null  && !is">-->
            <div class="col-3" *ngIf="monthlyLimitPercentage != null && myBusinessDashboard?.myBusiness.subAccountGovId == null">
              <div class="d-flex flex-column">
                <span class="font-14">{{ 'Monthly Limit' | translate }} {{ myBusinessDashboard?.monthlyLimit ?? '0' | number:'1.0-0' }} <img src="assets/sr.svg" alt="SAR"></span>
                <div class="progress">
                  <div class="progress-bar progress-bar-striped" [ngClass]="monthlyLimitColor" role="progressbar" [ngStyle]="{width: (monthlyLimitPercentage) + '%'}" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">{{ myBusinessDashboard?.currentLimit ?? '0' | number:'1.0-0' }}</div>
                </div>
                <div *ngIf="targetSalesRemaining != null">
                  <span *ngIf="targetSalesPercentage < 100" class="font-14">{{ 'للحصول على المكافأة باقي' | translate }} {{ targetSalesRemaining | number:'1.0-0' }} <img src="assets/sr.svg" alt="SAR"></span>
                  <span *ngIf="targetSalesPercentage >= 100" class="font-14">{{ 'مبروك! حققت الهدف لهذا الشهر' | translate }}</span>
                  <div class="progress my-0">
                    <div class="progress-bar progress-bar-striped" [ngClass]="incentiveLimitColor" role="progressbar" [ngStyle]="{width: (targetSalesPercentage) + '%'}" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">{{ targetSalesPercentage | number:'1.0-0' }} %</div>
                  </div>
                  <span *ngIf="targetSalesPercentage < 100" style="font-size: 6pt">{{ 'المبيعات المستهدفة' | translate }} {{ myBusinessDashboard?.totalSales.targetThisMonth | number:'1.0-0' }} <img src="assets/sr.svg" alt="SAR"></span>
                  <span *ngIf="targetSalesPercentage >= 100" style="font-size: 6pt" class="text-danger">{{ 'ستحصل على المكافأة بداية الشهر القادم' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div *ngIf="myBusinessDashboard?.myBusiness.subAccountGovId == null || isAccountant || isManager" class="my-1 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
      <div class="widget widget-account-invoice-one">
        <div class="widget-content">
          <div class="invoice-box">
            <div class="acc-total-info">
              <h5 translate>Balance</h5>
              <p class="acc-amount" [ngClass]="myBusinessDashboard?.myBusiness.walletAmount < 0? 'text-danger':'text-success'">{{ myBusinessDashboard?.myBusiness.walletAmount| number: '1.2-2' }} <img height="18" class="text-success" src="assets/sr.svg" alt="SAR"></p>
              <div *ngIf="myBusinessDashboard && myBusinessDashboard.myBusiness && myBusinessDashboard.myBusiness.pendingWithdrawsAmount" class="d-flex flex-row text-center">
                <p style="font-size: 8pt" class="mx-auto my-1 text-primary">({{ 'Under Transfer' | translate }} {{ myBusinessDashboard.myBusiness.pendingWithdrawsAmount| number: '1.2-2' }} <img height="18" src="assets/sr.svg" alt="SAR"></p>
              </div>
            </div>
            <div class="inv-detail">
              <div class="info-detail-1">
                <p translate>Today Sales</p>
                <p>{{ myBusinessDashboard?.totalSales.today| number: '1.2-2' }} <img height="18" src="assets/sr.svg" alt="SAR"></p>
              </div>
              <div class="info-detail-2">
                <p translate>This Month Sales</p>
                <p>{{ myBusinessDashboard?.totalSales.thisMonth| number: '1.2-2' }} <img height="18" src="assets/sr.svg" alt="SAR"></p>
              </div>
              <div class="info-detail-2">
                <p translate>This Year Sales</p>
                <p>{{ myBusinessDashboard?.totalSales.thisYear| number: '1.2-2' }} <img height="18" src="assets/sr.svg" alt="SAR"></p>
              </div>
            </div>
            <div class="inv-action">
              <a routerLink="/private/balance" class="btn btn-primary" translate>View</a>
              <!--            <a href="" class="btn btn-danger">Transfer</a>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-1 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
      <div class="widget widget-account-invoice-one">
        <div class="widget-content">
          <div class="invoice-box">
            <div class="acc-total-info">
              <h5 translate>New Orders</h5>
              <p class="acc-amount">{{ myBusinessDashboard?.countNewOrders }}</p>
            </div>
            <div class="inv-detail">
              <div class="info-detail-1">
                <p translate>Pending Orders Total Amount</p>
                <p>{{ myBusinessDashboard?.totalAmountOfPendingOrders | number: '1.2-2' }} <img height="18" src="assets/sr.svg" alt="SAR"></p>
              </div>
              <div class="info-detail-2">
                <p translate>Paid Invoices Count</p>
                <p>{{ myBusinessDashboard?.paidInvoicesCount }}</p>
              </div>
              <div class="info-detail-2">
                <p translate>Successful Transactions Today</p>
                <p>{{ myBusinessDashboard?.successfulTransactionToday }}</p>
              </div>
            </div>
            <div class="inv-action">
              <a routerLink="/private/orders/ordered" class="btn btn-primary" translate>View</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-1 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
      <div class="widget widget-account-invoice-one">
        <div class="widget-content">
          <div class="invoice-box">
            <div class="acc-total-info">
              <h5 translate>Products Count</h5>
              <p class="acc-amount">{{ myBusinessDashboard?.productsCount }}</p>
            </div>
            <div class="inv-detail">
              <div class="info-detail-1">
                <p translate>Products About To Finish</p>
                <p>{{ myBusinessDashboard?.productsAboutToOutOfStockCount }}</p>
              </div>
              <div class="info-detail-2">
                <p translate>Products Out Of Stock</p>
                <p>{{ myBusinessDashboard?.productsOutOfStockCount }}</p>
              </div>
              <div class="info-detail-2">
                <p translate>Products Online</p>
                <p>{{ myBusinessDashboard?.productsOnline }}</p>
              </div>
            </div>
            <div class="inv-action">
              <a routerLink="/private/products" class="btn btn-primary" translate>View</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="my-1 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="widget widget-account-invoice-one" *ngIf="myBusinessDashboard?.topTenProducts">
        <div class="widget-content">
          <div class="invoice-box">
            <div class="acc-total-info">
              <h5 translate>Top Ten Products</h5>
              <p class="acc-amount" style="font-size: 10pt;" translate>Based on number of sold products</p>
            </div>
            <div class="inv-detail">
              <div style="letter-spacing: normal !important;" id="products-sales" (ngInit)="setupTopProductsChart()"></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!myBusinessDashboard?.topTenProducts">
        <div class="d-flex">
          <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
        </div>
      </div>
    </div>


    <div class="my-1 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="widget widget-account-invoice-one" *ngIf="myBusinessDashboard?.topTenClients">
        <div class="widget-content">
          <div class="invoice-box">
            <div class="acc-total-info">
              <h5 translate>Top Ten Clients</h5>
              <p class="acc-amount" style="font-size: 10pt;" translate>Based on client purchases totals</p>
            </div>
            <div class="inv-detail">
              <div style="letter-spacing: normal !important;" id="daily-sales" (ngInit)="setupTopCustomerChart()"></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!myBusinessDashboard?.topTenClients">
        <div class="d-flex">
          <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<!-- ads note modal -->
<app-general-modal #generalModal [modalId]="'adsNoteModal'" [dynamicHtml]="adsHtmlContent" [modalSize]="'modal-lg'"/>
